<template>
	<el-container class="main">
		<div class="logos" :class="collapse?'collapse':''">
			<img v-if="!collapse" src="../assets/456.png" />
			<img v-else class="mini" src="../assets/logo_456.png" />
		</div>
		<el-aside class="aside" style="width: 10rem;" :class="collapse?'collapse':''">
			<leftMenu ref="menuCallback" />
		</el-aside>
		<el-container class="main-con">
			<el-header class="main-con-header">
				<topHeader ref="headerCallback" />
			</el-header>
			<!-- <div class="main-con-tips">当前浏览器可能导致后台访问异常，请使用Chrome/谷歌浏览器。百度搜索“chrome”。</div> -->
			<el-main class="main-con-box">
				<router-view @console_events="consoleEvents" ref="mainCallback" />
				<!-- <div class="arrow" :class="collapse?'collapse':''" @click="onCollapse">
					<i v-if="!collapse" class="el-icon-d-arrow-left"></i>
					<i v-else class="el-icon-d-arrow-right"></i>
				</div> -->
				<div class="copy">Copyright © 2015-2022 Jiazhi All Rights Reserved 佳智网络公司版权所有</div>
			</el-main>
		</el-container>
		<el-dialog title="安全验证" center width="30%" :visible="verify.show" :show-close="false">
			<div style="text-align: center;user-select: none;">
				<drag-verify-img-chip style="display: inline-block;" ref="dragVerify" :showRefresh="true" radius="0px"
					:width="250" :diffWidth="10" :height="35" textSize="12px" :imgsrc="verify.img"
					:isPassing.sync="verify.passing" text="按住滑块拖动完成拼图" successText="验证通过"
					handlerIcon="el-icon-d-arrow-right" successIcon="el-icon-circle-check" @refresh="verifyImg"
					@passcallback="verifyCallback" />
			</div>
			<div v-if="!verify.passing" style="margin: 1.25rem 0;text-align: center;font-size: 0.75rem;color: red;">
				<i class="el-icon-warning" style="margin-right: 0.1875rem;"></i>
				<span>未完成验证订单将无法通知，验证后继续...</span>
			</div>
			<div v-else style="margin: 1.25rem 0;text-align: center;font-size: 0.75rem;">
				<i class="el-icon-loading" style="margin-right: 0.1875rem;"></i>
				<span style="color: #67C23A;">正在进入...</span>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
	var globalInterval = null;
	var globalLoopNums = 0;
	import topHeader from '../components/topHeader.vue';
	import leftMenu from '../components/leftMenu.vue';
	import dragVerifyImgChip from "../components/dragVerifyImgChip";
	export default {
		data() {
			return {
				collapse: false,
				verify: {
					show: false,
					passing: false,
					img: ''
				}
			};
		},
		components: {
			topHeader,
			leftMenu,
			dragVerifyImgChip
		},
		mounted() {
			const that = this;
			that.verifyImg();
			that.$nextTick(function() {
				that.globalIntervals();
				document.body.style.overflow = "hidden";
			});
			// that.initSocket();
		},
		destroyed() {
			if (globalInterval) {
				clearInterval(globalInterval);
				globalInterval = null;
			}
		},
		// destroyed() {
		// 	// 销毁监听
		// 	this.socket.onclose = this.closeSocket;
		// },
		methods: {
			onCollapse() {
				this.collapse = !this.collapse;
				this.$refs.menuCallback.onCollapse();
			},
			// initSocket() {
			// 	const that = this;
			// 	if (typeof(WebSocket) === "undefined") {
			// 		that.$message({
			// 			message: '您的浏览器不支持WebSocket！',
			// 			type: 'error',
			// 			duration: 10000,
			// 			showClose: true
			// 		});
			// 	} else {
			// 		// 实例化socket
			// 		that.socket = new WebSocket("ws://8.135.112.77:2345");
			// 		// 监听socket连接
			// 		that.socket.onopen = that.openSocket;
			// 		// 监听socket错误信息
			// 		that.socket.onerror = that.errorSocket;
			// 		// 监听socket消息
			// 		that.socket.onmessage = that.messageSocket;
			// 	}
			// },
			// openSocket() {
			// 	this.$refs.headerCallback.setServer(1);
			// 	//启动定时心跳
			// 	this.heartSocket();
			// },
			// errorSocket() {
			// 	console.log("连接错误")
			// },
			// messageSocket(message) {
			// 	console.log("接收消息", message);
			// },
			// closeSocket() {
			// 	console.log("关闭连接")
			// 	this.$refs.headerCallback.setServer(2);
			// },
			globalIntervals() {
				const that = this;
				if (!globalInterval) {
					console.log("启动全局定时");
					globalInterval = setInterval(function() {
						that.$refs.headerCallback.setDate();
						if (that.$route.name == "order_dispatch" && (globalLoopNums % 30) == 29) {
							that.$refs.mainCallback.postDispatch();
						}
						globalLoopNums++;
					}, 1000);
				} else {
					clearInterval(globalInterval);
					setTimeout(function() {
						that.globalIntervals();
					}, 1e3);
				}
			},
			verifyImg() {
				var i = Math.floor(Math.random() * 10) + 1;
				this.verify.img = "../static/img/verify" + i + ".jpg";
				this.verify.show = true;
			},
			verifyCallback() {
				const that = this;
				console.log("验证成功", that.$route.name);
				if (that.$route.name == "order") {
					// that.$refs.mainCallback.setNotify();
				}
				setTimeout(function() {
					that.verify.show = false;
				}, 1000);
			},
			consoleEvents(e) {
				const that = this;
				if (e.mode == "header") {
					//刷新顶部区域
					that.$refs.headerCallback.setInfo();
				}
			}
		}
	}
</script>

<style scoped>
	.main,
	.main-son {
		position: relative;
		height: 100%;
		width: 100%;
		box-sizing: border-box;
	}

	.main .logos {
		position: absolute;
		top: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-weight: bold;
		text-align: center;
		width: 10rem;
		height: 3.05rem;
		line-height: 3.05rem;
		user-select: none;
		background-color: #00aeff;
	}

	.main .logos img {
		width: 6rem;
	}

	.main .logos.collapse {
		width: 5rem;
	}

	.main .logos.collapse img {
		width: 2.5rem;
	}

	/* 	.main .logo img {
		width: 1.875rem;
		height: 1.875rem;
		margin-right: 0.3rem;
	} */

	.main .aside {
		width: 10rem;
		margin-top: 3.05rem;
		background-color: #2a3542;
		overflow-x: hidden !important;
		overflow-y: auto !important;
	}

	.main .aside::-webkit-scrollbar {
		width: 0.375rem;
		height: 0.375rem;
	}

	.main .aside::-webkit-scrollbar-thumb {
		border-radius: 0.625rem;
		background-color: #8c8c8c;
		-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.3);
	}

	.main .aside.collapse {
		width: 5rem !important;
	}

	.main-con-header {
		height: 3.125rem !important;
		border-bottom: 1px #eee solid;
	}
	
	.main-con-tips {
		color: #f60;
		font-size: 0.75rem;
		padding: 0.25rem 0;
		text-align: center;
		background-color: #fdfbc9;
		border-bottom: 1px #eee solid;
	}

	.main-con-box {
		background-color: #f0f2f5;
	}

	.main-con-box::-webkit-scrollbar {
		width: 0.375rem;
		height: 0.375rem;
	}

	.main-con-box::-webkit-scrollbar-thumb {
		border-radius: 0.625rem;
		background-color: #8c8c8c;
		-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.3);
	}

	.main-con-box .arrow {
		position: absolute;
		top: 3.05rem;
		left: 10rem;
		width: 1rem;
		line-height: 2.5rem;
		text-align: center;
		cursor: pointer;
		background-color: #415060;
		border-top-right-radius: 0.3125rem;
		border-bottom-right-radius: 0.3125rem;
	}

	.main-con-box .arrow.collapse {
		left: 5rem;
	}

	.main-con-box .arrow i {
		font-size: .75rem;
		color: white;
	}
	
	.main-con-box .copy {
		color: #999;
		text-align: center;
		font-size: 0.75rem;
		margin-top: 1.25rem;
	}

/* 	.main-son>>>.el-menu {
		border-right: none;
	}

	.main-son>>>.el-menu .el-menu-item, .main-son>>>.el-menu .el-submenu__title {
		font-size: 0.8125rem;
		height: 2.75rem;
		line-height: 2.75rem;
	}
	
	.main-son>>>.el-menu .el-menu-item.is-active {
		background-color: #ecf5ff;
	}
	
	.main-son>>>.el-menu .el-menu-item .el-menu-item-group__title {
		padding: 0;
	} */
</style>
